import gql from 'graphql-tag';

export const hierarchyAuthTokenCreate = gql`
  mutation hierarchyAuthTokenCreate($input: HierarchyAuthTokenCreateInput!) {
    hierarchyAuthTokenCreate(input: $input) {
      auth_token
    }
  }
`;
